<template>
  <div class="calculation-box">
    <div class="calculation-box__title">總價折抵</div>
    <div class="calculation-box__list price-discount">
      <div class="single-input-field">
        <p class="input-title">折扣(%)</p>
        <div class="custom-input">
          <input
            type="text"
            placeholder="9折輸入9,85折輸85"
            autocomplete="off"
            class="custom-text"
            v-model.number="discountPercentage"
          />
          <div class="unit">折</div>
        </div>
      </div>

      <div class="single-input-field">
        <p class="input-title">折價(元)</p>
        <div class="custom-input">
          <input
            type="text"
            placeholder="請輸入折抵價格"
            autocomplete="off"
            class="custom-text"
            v-model.number="discountPrice"
          />
          <div class="unit">元</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    discountType: {
      required: false,
      type: String
    },
    amount: {
      required: false,
      type: Number
    },
    discountPriceMax: {
      required: false,
      type: Number
    }
  },
  computed: {
    discountPercentage: {
      get() {
        return this.discountType == 1 ? this.amount : null;
      },
      set(val) {
        if (val < 10) {
          val *= 10;
        }

        val = val > 100 ? 100 : val;

        val > 0 ? this.updateDiscount(val, '1') : this.noDiscount();
      }
    },
    discountPrice: {
      get() {
        return this.discountType == 2 ? this.amount : null;
      },
      set(val) {
        val = val > this.discountPriceMax ? this.discountPriceMax : val;

        val > 0 ? this.updateDiscount(val, '2') : this.noDiscount();
      }
    }
  },
  methods: {
    noDiscount() {
      this.$emit('updateTotalDiscount', {
        discountType: '0',
        amount: 0
      });
    },
    updateDiscount(val, type) {
      this.$emit('updateTotalDiscount', {
        discountType: type,
        amount: val
      });
    }
  }
};
</script>
